"use client";

import UserInfo from "@/03-presenters/components/UserInfo";
import "./index.css";
export default function UserInfoWrapper() {
  return <UserInfo className="h-6 rounded-[4rem] px-2 text-xs font-medium sm:h-9 sm:rounded-[9rem] sm:px-4 sm:text-base " data-sentry-element="UserInfo" data-sentry-component="UserInfoWrapper" data-sentry-source-file="UserInfoWrapper.tsx" />;
}